var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-4" },
    [
      !_vm.showNoRowsText
        ? _c("b-table", {
            attrs: { fields: _vm.tableFields, items: _vm.getTableItems },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(invoicingModalityArticleName)",
                  fn: function (rowData) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm
                              .getRowForm(rowData)
                              .getDataOfProperty("invoicingModalityArticleName")
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(serviceRecipientFirmName)",
                  fn: function (rowData) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm
                              .getRowForm(rowData)
                              .getDataOfProperty("serviceRecipientFirmName")
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(fee)",
                  fn: function (rowData) {
                    return [
                      _c("csp-form-group-input-currency", {
                        attrs: {
                          form: _vm.getRowForm(rowData),
                          "hide-arrows": "",
                          "hide-label": "",
                          list: "fee-suggestions",
                          property: "fee",
                          readonly: _vm.isFeeInputReadonly(rowData),
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(invoiceRecipient)",
                  fn: function (rowData) {
                    return [
                      _c("csp-form-group-select-searchable", {
                        attrs: {
                          form: _vm.getRowForm(rowData),
                          "hide-label": "",
                          options: _vm.invoiceRecipientOptions,
                          property: "invoiceRecipient",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.handleInvoiceRecipientChange(
                              $event,
                              rowData
                            )
                          },
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(invoiceRecipientAddressNo)",
                  fn: function (rowData) {
                    return [
                      _c("csp-form-group-input", {
                        attrs: {
                          disabled: _vm.isAddressNoInputDisabled(rowData),
                          form: _vm.getRowForm(rowData),
                          "hide-label": "",
                          property: "invoiceRecipientAddressNo",
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              645628382
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "datalist",
        { attrs: { id: "fee-suggestions" } },
        _vm._l(_vm.feeSuggestions, function (feeSuggestion, index) {
          return _c("option", { key: index }, [
            _vm._v("\n            " + _vm._s(feeSuggestion) + "\n        "),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.showNoRowsText
        ? _c("div", [_vm._v("\n        " + _vm._s(_vm.noRowsText) + "\n    ")])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }